import { useTheme } from "styled-components";
import { useMedia } from "react-media";
function useResponsiveProp(prop) {
    if (!Array.isArray(prop)) {
        return prop;
    }
    var theme = useTheme();
    var breakpoints = theme.breakpoints;
    var mediaQueries = prop.reduce(function (acc, next, index) {
        acc[index] = "(min-width: " + breakpoints[index] + ")";
        return acc;
    }, {});
    var matches = useMedia({ queries: mediaQueries });
    var value = prop[0];
    for (var _i = 0, _a = Object.entries(matches).reverse(); _i < _a.length; _i++) {
        var entry = _a[_i];
        if (entry[1]) {
            value = prop[Number(entry[0])];
            break;
        }
    }
    return value;
}
export default useResponsiveProp;
//# sourceMappingURL=useResponsiveProp.js.map